const DYNAMIC_IMPORT_ERROR_PATTERN = /(?:Failed to fetch dynamically imported module|Importing a module script failed|error loading dynamically imported module|ChunkLoadError)/i
const ROUTE_CHUNK_RELOAD_PREFIX = 'model-eval:route-chunk-reload:'

export function isDynamicImportFetchError(error: unknown): boolean {
  const message = error instanceof Error ? error.message : String(error ?? '')
  return DYNAMIC_IMPORT_ERROR_PATTERN.test(message)
}

export function routeChunkReloadKey(path: string): string {
  return `${ROUTE_CHUNK_RELOAD_PREFIX}${path}`
}
